import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

import Icon, { IconPropTypes } from "components/library/Icon";

import styles from "./IconButton.css";

export default function IconButton({
  className,
  description,
  name,
  to,
  ...nativeProps
}) {
  const mergedProps = {
    ...nativeProps,
    className: classNames(styles.root, className),
    ...(to && { to }),
  };

  const icon = (
    <Icon
      className={classNames(styles.icon, {
        [styles.featherIcon]: !["go-deeper", "h2", "list-ordered"].includes(
          name
        ),

        // Add custom styles for custom icons not from https://feathericons.com
        [styles.goDeeper]: name === "go-deeper",
        [styles.h2]: name === "h2",
        [styles.listOrdered]: name === "list-ordered",
      })}
      description={description}
      name={name}
    />
  );

  return to ? (
    <Link {...mergedProps}>{icon}</Link>
  ) : (
    <button {...mergedProps}>{icon}</button>
  );
}

IconButton.propTypes = {
  ...IconPropTypes,
  // Pass additional classNames to be added
  className: PropTypes.string,
  to: PropTypes.string,
};
